import { mapActions, mapGetters } from 'vuex';
import { NotificationSlugs, NotificationSubjectTypes } from '@/util/constants/notificationSlugs';
import { tenantHasGonogoAccess } from '@/util/module-access-util';

/**
 * Opening a notification behaves the same wherever it is listed (nav panel, "see more" dialog):
 * mark it read, then route to its subject. Only the dismissal differs, so callers run their own
 * close after `openNotification`.
 *
 * A subject cached as `null` no longer exists — the route would 404, so the click does nothing.
 * `undefined` means the subject fetch has not resolved yet, which still routes: the target page
 * loads it itself.
 *
 * A vote invitation lands on the Go/No-Go page when the tenant has the module (the route guard
 * would 404 otherwise); the details page is the fallback.
 */
export default {
  computed: {
    ...mapGetters('notifications', ['tenderById', 'opportunityById']),
  },
  methods: {
    ...mapActions('notifications', ['markAsRead']),
    notificationRoute(notification) {
      const { eventType, subjectType, subjectId } = notification.content;

      if (subjectType === NotificationSubjectTypes.OPPORTUNITY) {
        if (this.opportunityById(subjectId) === null) return null;

        const name =
          eventType === NotificationSlugs.OPPORTUNITY_VOTE_INVITATION && tenantHasGonogoAccess()
            ? 'opportunity-go-nogo'
            : 'opportunity-details';
        return { name, params: { opportunityId: subjectId } };
      }

      if (this.tenderById(subjectId) === null) return null;
      return { name: 'tender-details', params: { id: subjectId } };
    },
    openNotification(notification) {
      if (!notification.isRead) {
        this.markAsRead(notification.id);
      }

      const route = this.notificationRoute(notification);
      // Navigating to the route already shown rejects; that is not an error worth surfacing.
      if (route) this.$router.push(route).catch(() => {});
    },
  },
};
